/**
 * Suffix appended to custom procedure displays in combined procedure ValueSet expansions.
 * `CodingInputWithDetails` parses this suffix to show an inline badge so users can distinguish
 * practice custom codes from standard listings that share the same numeric code.
 *
 * **Constraint:** Any display that ends with this exact phrase (after trim) is treated as
 * practice-custom in the picker. Standard terminology rows whose label happens to end with
 * `" Custom Code"` could show the badge incorrectly; in practice only values from
 * {@link formatCustomProcedureOptionDisplay} in `@/shared/utils/custom-procedure-option-display` should use this suffix.
 */
export const CUSTOM_PROCEDURE_OPTION_DISPLAY_SUFFIX = "Custom Code";
